import { render, staticRenderFns } from "./MainMessageForm.vue?vue&type=template&id=6d6ceb61&scoped=true&"
import script from "./MainMessageForm.vue?vue&type=script&lang=js&"
export * from "./MainMessageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6ceb61",
  null
  
)

export default component.exports